import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ReportDetailsComponent } from "./report-details/report-details.component";
import { ReportsComponent } from "./reports/reports.component";

const routes: Routes = [
	{
		path: "",
		component: ReportsComponent,
	},
	{
		path: ":id",
		component: ReportDetailsComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ReportsRoutingModule {}
